import { cloneElement, Component } from '~preact';
import PropTypes from "prop-types";
import withThemeComponentsContext from "./hoc/withThemeComponentsContext";
import { IS } from "@green24/npm-javascript-utils";
import { ComponentUtils } from "../../class/ComponentUtils";
import { AppUtils } from "../../class/AppUtils";

class ThemeComponent extends Component {
	render({themeComponentsContext, componentType, fallback, suppressErrors, componentProps, ...props}) {
		const propsToPropagate = {...props, ...componentProps};

		if(themeComponentsContext) {
			if(IS.fnc(themeComponentsContext[componentType])) {
				return themeComponentsContext[componentType](propsToPropagate, fallback);
			}

			AppUtils.isDev &&
			!suppressErrors &&
			console[fallback ? "warn" : "error"](`Component not found for "${componentType}" component type.${fallback ? ` For now, a fallback was used. If this is a desired behavior, consider mapping said component type in form of "(props, fallback) => fallback(props) or add"` : " Please define the component. If this is a desired behavior, consider adding"} suppressErrors={true} prop onto this component.`);
		}
		else {
			AppUtils.isDev &&
			!suppressErrors &&
			console[fallback ? "warn" : "error"](`ThemeComponentsContext was not found for the ThemeComponent component.\nCompletely reload the page and if the problem persists, check if the context provider is missing.${fallback ? " For now, a fallback was used." : ''}`);
		}

		return ComponentUtils.resolvePolymorphProp(
			fallback,
			{
				component: c => cloneElement(c, propsToPropagate),
				function: f => f(propsToPropagate),
			},
			() => fallback,
		);
	}

	static get propTypes() {
		return {
			className: PropTypes.string,
			style: PropTypes.object,
			children: PropTypes.any,

			componentType: PropTypes.string,
			componentProps: PropTypes.object,

			//Fallback component if the componentType or themeComponentsContext could not be found.
			fallback: PropTypes.any,

			suppressErrors: PropTypes.bool,

			//withThemeComponentsContext
			themeComponentsContext: PropTypes.object,
		}
	}
}

export default withThemeComponentsContext(ThemeComponent);
